import api from '../api';

const DISCHARGE_STEPS = api.events.dischargeSteps.actionSuccess;

const defaultState = { dischargeSteps: [] };

export default (state = defaultState, action) => {
  switch (action.type) {
    case DISCHARGE_STEPS:
      return { ...state, dischargeSteps: action.data };
    default:
      return state;
  }
  
};



// WEBPACK FOOTER //
// ./src/reducers/dischargeSteps.js